/**
 * "Last store used" in this browser (PLAN §4.7) — a per-device convenience,
 * not household data, so it lives in localStorage and never reaches the
 * server. New grocery lists default to it. Every access is guarded: storage
 * can be missing or throw (private windows, blocked site data).
 */

export const LAST_STORE_KEY = 'fewerbags.lastStoreId';

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

function defaultStorage(): StorageLike | null {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function loadLastStoreId(storage: StorageLike | null = defaultStorage()): string | null {
  try {
    const value = storage?.getItem(LAST_STORE_KEY);
    return value ? value : null;
  } catch {
    return null;
  }
}

export function saveLastStoreId(
  storeId: string | null | undefined,
  storage: StorageLike | null = defaultStorage(),
): void {
  // Clearing a list's store doesn't forget the last one you shopped at.
  if (!storeId) return;
  try {
    storage?.setItem(LAST_STORE_KEY, storeId);
  } catch {
    // Best-effort — never break saving a list over a storage error.
  }
}
